export const pushTrackIDs = {
    popup: 'dagligbank-lokalbank-push-popup',
    nudge: 'dagligbank-lokalbank-push-nudge',
    privacy: 'dagligbank-lokalbank-push-privacy',
    enable: 'dagligbank-lokalbank-push-enable',
    toggle: {
        EFAKTURA_EVENT: 'dagligbank-lokalbank-push-enable-new-efaktura',
        EFAKTURA_WITH_AVTALEGIRO_EVENT: 'dagligbank-lokalbank-push-enable-new-efaktura-with-avtalegiro',
        SHARED_EFAKTURA_EVENT: 'dagligbank-lokalbank-push-enable-shared-efaktura',
        MESSAGE_EVENT: 'dagligbank-lokalbank-push-message-from-advisor',
        SHARED_ACCOUNT: 'dagligbank-lokalbank-push-enable-shared-account',
        LOAN_APPLICATION_EVENT: 'dagligbank-lokalbank-push-loan-application',
        OVERDUE_EFAKTURA_EVENT: 'dagligbank-lokalbank-push-overdue-efaktura',
        STOPPED_PAYMENT_EVENT: 'dagligbank-lokalbank-push-stopped-payment',
        STUDENT_LOAN_CONSENT_EVENT: 'dagligbank-lokalbank-push-studentloan-consent',
        salary: 'dagligbank-lokalbank-push-salary-into-account',
        account: 'dagligbank-lokalbank-push-transaction-for-account',
        UNKNOWN: 'N/A',
    },
};
